import { render, staticRenderFns } from "./tab-inquiry.vue?vue&type=template&id=0f47460a"
import script from "./tab-inquiry.vue?vue&type=script&lang=js"
export * from "./tab-inquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports